/**
 * Browser SHA-256 — matches the worker's persisted-ops hash exactly.
 *
 * Why a tiny module: the SPA computes hashes for `BUILD_TX_QUERY` and
 * `TX_STATUS_QUERY` at app boot, then sends them via APQ extensions
 * (`extensions.persistedQuery.sha256Hash`) on every request. The worker's
 * persisted-ops plugin (`apps/api/src/graphql/persistedOperations.ts`)
 * looks up `pq:<hash>` in KV — bytes-for-bytes identical to what the
 * publisher script (`scripts/publish-queries.ts`) used.
 *
 * Why WebCrypto (`crypto.subtle.digest`) instead of a hashing lib: zero
 * dependency, identical algorithm to the worker (which also uses WebCrypto
 * via the same primitive). Available in every modern browser since 2017.
 */
export async function sha256Hex(input: string): Promise<string> {
  const enc = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest("SHA-256", enc);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
